type TContentByKey = {
  entity_id: null | string
  name: null | string
  key: string
  json: null | string
}
type TCommonContent = {
  name: string
  image: string
  meta_robots: string
  url_key: string
  post_content: string
  enabled: number
  view_traffic: 1000
  publish_date: string
}
type TPolicyContent = {
  name: string
  short_description: string
  link_url: string
}
type TNewCovertData = {
  type: string
  items: TCommonContent
}
export enum LIST_TYPE {
  COMMON = 'blog',
  LIST = 'list',
  COLLAPSE = 'collapse',
}
export type { TContentByKey, TCommonContent, TPolicyContent, TNewCovertData }
